import { render, staticRenderFns } from "./Purchase.vue?vue&type=template&id=ea2ed050&scoped=true&"
import script from "./Purchase.vue?vue&type=script&lang=js&"
export * from "./Purchase.vue?vue&type=script&lang=js&"
import style0 from "./Purchase.vue?vue&type=style&index=0&id=ea2ed050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea2ed050",
  null
  
)

export default component.exports